import { Check, Polygon, X } from "phosphor-react-sc"
import { useMapId, useActivateMultiSelect, useSetActivateMultiSelect } from "../../../hooks/useMapStore";

interface MapControlMultiSelectProps {
    show?: boolean,
    onCancelClick: () => void,
    onOkClick: () => void,
}
export const MapControlMultiSelect = ({
    show = false,
    onCancelClick,
    onOkClick,
}: MapControlMultiSelectProps) => {

    const mapId = useMapId();
    const activateMultiSelect = useActivateMultiSelect();
    const setActivateMultiSelect = useSetActivateMultiSelect();

    const multiElemId = `googleMapControlMulti-${mapId}`;
    const multiButtonElemId = `googleMapControlMultiButton-${mapId}`;

    return (
        show &&
        <div id={multiElemId} className={`google-map-control-multi ${activateMultiSelect ? "google-map-control-multi-active" : ""}`}>
            <div>
                <div
                    onClick={handleOnOkClick}
                    className="gmcmb gmcms">
                    <Check size={20} />
                </div>
                <div
                    onClick={handleOnCancelClick}
                    className="gmcmb gmcmc" style={{
                        backgroundColor: "var(--error)"
                    }}>
                    <X size={20} />
                </div>
            </div>
            <div
                id={multiButtonElemId}
                onClick={handleOnClick}
                    data-active={activateMultiSelect}
                    className={`gmcmb gmcmm ${activateMultiSelect ? "google-map-control-button-active" : ""}`}>
                <Polygon size={20} />
            </div>
        </div>
    )

    function handleOnClick() {
        if (activateMultiSelect) {
            onCancelClick();
        }
        setActivateMultiSelect(!activateMultiSelect);
    }

    function handleOnOkClick() {
        setActivateMultiSelect(!activateMultiSelect);
        onOkClick();
    }

    function handleOnCancelClick() {
        setActivateMultiSelect(!activateMultiSelect);
        onCancelClick();
    }
}
